import {Scroll} from "./Scroll";
import {Banner} from "./Banner";
import {Menu} from "./Menu";
import {Bootstrap} from "./Bootstrap";
import {Video} from "./Video";
import {AfterFacility} from "./AfterFacility";
import {Opener} from "./Opener";
import {Program} from "./Program";

class Main {
	
	static IS_FRONT_PAGE = false;
	
	static init() {
		Bootstrap.init();
		if (location.hash != '') {
			Bootstrap.loadLazyImages();
		}
		window.addEventListener('load', this.onLoad.bind(this));
		document.addEventListener('DOMContentLoaded', this.onDomLoad.bind(this));
	}
	
	static onDomLoad() {
		
		Main.IS_FRONT_PAGE = document.body.classList.contains('home');
		if (Main.IS_FRONT_PAGE) {
			if (sessionStorage.getItem("visited")) {
				document.body.classList.add('is-first-visit');
			} else {
				sessionStorage.setItem("visited", 1)
			}
		}
		Scroll.init();
		Banner.init();
		AfterFacility.init();
		Opener.init();
		Program.init();
		new Menu();
	}
	
	static onLoad() {
		console.log('loaded');
		$.fancybox.defaults.animationEffect = "fade";
		document.body.classList.add('is-loaded');
		Video.init();
		_.defer(()=>{
			if (location.hash != '') {
				Scroll.toScroll(location.hash,3);
			}else{
				Bootstrap.loadLazyImages();
			}
		});
	}
}
Main.init();